import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import CreateUpdateContainer from '../../components/CreateUpdateContainer/CreateUpdateContainer';
import useFields from './fields';

const CreateUpdateInsurer = ({ purpose }) => {
  const { t } = useTranslation();
  const [initialValues, setInitialValues] = useState();
  const [form] = Form.useForm();
  const { getFields } = useFields(t, null, purpose, form);

  const fields = useMemo(() => {
    return getFields(initialValues);
  }, [initialValues, getFields]);

  const config = {
    onUpdateResource: {
      setBody: (data) => ({
        ...data,
        insurer_type: {
          value: data.insurer_type_value,
          comment: data.insurer_type_comment
        },
        address: {
          number: data.number,
          street: data.street,
          additional: data.additional,
          postal_code: data.postal_code,
          city: data.city
        }
      })
    },
    onCreateResource: {
      setBody: (data) => ({
        ...data,
        address: {
          number: data.number,
          street: data.street,
          additional: data.additional,
          postal_code: data.postal_code,
          city: data.city
        }
      })
    },
    onGetResource: {
      setFields: (data) => {
        const tmpDefaultValues = {
          ...data,
          insurer_type_value: data.insurer_type && data.insurer_type.value,
          insurer_type_comment: data.insurer_type && data.insurer_type.comment,
          number: data.address && data.address.number,
          street: data.address && data.address.street,
          additional: data.address && data.address.additional,
          postal_code: data.address && data.address.postal_code,
          city: data.address && data.address.city
        };
        setInitialValues(tmpDefaultValues);
        return tmpDefaultValues;
      }
    }
  };

  return (
    <CreateUpdateContainer
      resource="insurers"
      fields={fields}
      config={config}
      purpose={purpose}
      baseUrl="insurers"
      customForm={form}
    />
  );
};

CreateUpdateInsurer.propTypes = {
  purpose: PropTypes.string.isRequired
};

export default CreateUpdateInsurer;
